<template>
  <div>
    <PageAllow controller="ThirdAccountInfo" action="index" />
    <Breadcrumbs :items="items" />

    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                      v-model="options"
                      type="datetime"
                      show-radios
                      :radios="datetimeRadios"
                      removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <!-- 汇付账户 -->
                <v-col cols="12" sm="6" md="4" >
                  <SearcherKeyword
                          ref="keyword"
                          v-model="options.in_ext_code"
                          @text="in_ext_code = $event"
                          :label="$t('HuifuPay.Keyword')"
                  />
                </v-col>
                <!-- 汇付账户 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherThirdAccount v-model="thirdAccountSelected" type="101"/>
                </v-col>
                <!-- 凭证号 -->
                <v-col cols="12" sm="6" md="4" >
                  <SearcherKeyword
                          ref="keyword"
                          v-model="options.voucher_code"
                          @text="voucher_code = $event"
                          :label="$t('HuifuPay.Fields.voucherCode')"
                  />
                </v-col>
                <!-- 流水类型 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                          v-model="options.io_types"
                          :items="$consts.huifu.huifu_io_type"
                          :label="$t('HuifuPay.Fields.ioType')"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <div class="mx-4 mb-4">
          <v-data-table
            :headers="headers"
            :items="huifuPay"
            :loading="loading"
            :options.sync="options"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-2 px-4 pt-1 sticky-table sticky-last-col"

            id="sticky-table"
            fixed-header
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:header.actions="{ header }">
              {{ header.text }}
              <v-icon x-small>fa-sliders-h</v-icon>
            </template>
            <template v-slot:item.out_ext_code="{ item }">
              <span v-if="item.io_type == 1">
                 {{ item.out_ext_code }}({{ $t('HuifuPay.Fields.baseHuifuAccount') }})
              </span>
              <span v-else>
                 {{ item.out_ext_code }}
              </span>
            </template>
            <template v-slot:item.in_ext_code="{ item }">
               <span v-if="item.io_type == 1">
                 {{ item.in_ext_code }}
              </span>
              <span v-else>
                 {{ item.in_ext_code }}({{ $t('HuifuPay.Fields.baseHuifuAccount') }})
              </span>
            </template>
            <template v-slot:item.third_account_info.company_name="{ item }">
               <span v-if="item.io_type == 1">
                 {{ item.third_account_info.company_name }}
              </span>
              <span v-else>
                 {{ $t('HuifuPay.Fields.baseHuifuAccount') }}
              </span>
            </template>
            <template v-slot:item.ord_amt="{ item }">
              <span>
                 {{ item.ord_amt.toFixed(2) }}
              </span>
            </template>
            <template v-slot:item.req_time="{ item }">
              <span>
                 {{ item.req_time | formatTime }}
              </span>
            </template>
            <template v-slot:item.io_type="{ item }">
              <v-chip
                small
                label
                :color="item.io_type | huifuIoTypeColor"
                :text-color="item.io_type | huifuIoTypeTextColor"
              >
                {{ item.io_type | huifuIoTypeText }}
              </v-chip>
            </template>
            <template v-slot:item.actionsBtn="{ item }">
              <v-btn
                      v-if="item.actions.refund"
                      small
                      dark
                      color="primary"
                      class="px-2 me-2 mb-1"
                      @click.stop="
                      returnDialog = true;
                      payItem = item;
                    "
              >
                {{ $t("HuifuAccount.actionBtn.return") }}
              </v-btn>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>
    <!-- 退款 -->
    <ReturnDialog
            v-model="returnDialog"
            :item="payItem"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherThirdAccount from "@/components/plugins/SearcherThirdAccount";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import ThirdAccountInfo from "@/api/third-account-info";
import ReturnDialog from "./plugins/ReturnDialog";

const defaultOptions = {
  datetimeRadioSelected: "req",
  req_time_from:
          new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
                  .toISOString()
                  .substr(0, 10) + " 00:00:00",
  req_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  in_ext_code: "",
  voucher_code: "",
  io_types: [],
  third_account_id: 0,
  pay_type: [101, 102],
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherThirdAccount,
    SearcherStatus,
    ReturnDialog,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.thirdPayment"),
          disabled: false,
          href: "/huifu",
        },
        {
          text: i18n.t("Nav.huifuPay"),
          disabled: true,
          href: "/huifu-pay",
        },
      ];
    },
    datetimeRadios: () => [
      {
        key: "req",
        text: i18n.t("HuifuPay.Fields.reqTime"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("HuifuPay.Fields.outExtCode"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "out_ext_code",
        },
        {
          text: i18n.t("HuifuPay.Fields.inExtCode"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "in_ext_code",
        },
        {
          text: i18n.t("HuifuPay.Fields.companyName"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "third_account_info.company_name",
        },
        {
          text: i18n.t("HuifuPay.Fields.ordAmt"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "ord_amt",
        },
        {
          text: i18n.t("HuifuPay.Fields.reqTime"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "req_time",
        },
        {
          text: i18n.t("HuifuPay.Fields.ioType"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "io_type",
        },
        {
          text: i18n.t("HuifuPay.Fields.createrName"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          width: "110",
          value: "creater_name",
        },
        {
          text: i18n.t("HuifuPay.Fields.voucherCode"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "voucher_code",
        },
        {
          text: i18n.t("HuifuPay.Fields.returnVoucherCode"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "reutrn_voucher_code",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "actionsBtn",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "stickTableCols"]),
  },

  mounted() {
    this.$commonUtils.loadOptions("huifuPay", ["thirdAccountSelected"]).then(
      function (data) {
        if (data.options) {
          this.options = data.options;
        } else this.resetSearch();

        data.selecteds.forEach((selected) => {
          switch (selected.key) {
            case "thirdAccountSelected":
              this.thirdAccountSelected = selected.value;
              break;
          }
        });
      }.bind(this)
    );
  },

  data: () => ({
    huifuPay: [],
    in_ext_code: "",
    voucher_code: "",
    thirdAccountSelected: null,
    options: JSON.parse(
      sessionStorage.getItem("huifuPay-options")
        ? sessionStorage.getItem("huifuPay-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    returnDialog: false,
    payItem: {}
  }),

  methods: {
    resetSearch() {
      this.thirdAccountSelected = null;
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.in_ext_code, this.$refs.voucher_code].forEach((k) => {
        if (k) k.clear();
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        in_ext_code: this.in_ext_code,
        voucher_code: this.voucher_code
      });
    },
    getHuifuPayRecordsFromAPI() {
      ThirdAccountInfo.getHuifuPayRecordList(this.options).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.huifuPay = response.data.third_pay_records;
            this.paging = response.data.paging;
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      // immediate: true, //为避免覆盖session里保存的options，不能启用immediate
      deep: true,
      handler() {
        this.getHuifuPayRecordsFromAPI();
        sessionStorage.setItem(
          "huifuPay-options",
          JSON.stringify(this.options)
        );
      },
    },
    dataItem() {
      try {
        JSON.parse(this.dataItem)
        this.jsonData = JSON.parse(this.dataItem)
      } catch (error) {
        if(this.dataItem == null){
          this.jsonData = {}
        }else if(this.dataItem.length > 0 ){
          this.jsonData = this.dataItem
        }
      }
    },
    returnDialog: {
      handler() {
        if (!this.returnDialog) {
          this.getHuifuPayRecordsFromAPI();
        }
      }
    },
    thirdAccountSelected: {
      handler() {
        this.options.third_account_id = this.thirdAccountSelected;
        sessionStorage.setItem(
                "huifu-thirdAccountSelected",
                JSON.stringify(this.thirdAccountSelected)
        );
      },
    },
  },
};
</script>